import { Link } from "react-router-dom";

import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Checkbox,
  Container,
  Typography,
  Paper,
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  Avatar,
  Stack,
  Fade,
  Zoom,
  Grid,
  Divider,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  CheckCircle as CheckIcon,
  ArrowForward as ArrowForwardIcon,
  School as SchoolIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Badge as BadgeIcon,
  Lock as LockIcon,
  Groups as GroupsIcon,
  Business as BusinessIcon,
  MenuBook as MenuBookIcon,
} from "@mui/icons-material";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import RegistrationStepper from "../../components/RegistrationStepper";
// import "../styles/StudentRegistration.css";
import "../../styles/StudentRegistration.css"

import api from "../../api";
import { departmentOptions, yearOptions } from "../../data/academicOptions";

/* ------- Data ------- */
 
// const colleges = [
//   "Indian Institute of Technology Delhi",
//   "Indian Institute of Technology Bombay",
//   "Birla Institute of Technology and Science, Pilani",
//   "National Institute of Technology Trichy",
//   "Indian Institute of Science Bangalore",
//   "Delhi Technological University",
//   "Netaji Subhas Institute of Technology",
// ];

const registrationSteps = ["Choose Role", "Create Account", "Get Started"];

/* ------- Component ------- */

const ModernStudentRegistration = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Stepper
  const [currentStep, setCurrentStep] = useState(2);
  const totalSteps = 3;

  const [isSignupSuccess, setIsSignupSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [createdUser, setCreatedUser] = useState({ name: "", username: "" });

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [sentEmail, setSentEmail] = useState("");
  const [otpInvalidated, setOtpInvalidated] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [otpNotice, setOtpNotice] = useState('');
  const [otpCooldown, setOtpCooldown] = useState(0);

  useEffect(() => {
    if (!otpCooldown) return;
    const t = setInterval(() => {
      setOtpCooldown((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(t);
  }, [otpCooldown]);

  // Form state
  const [formData, setFormData] = useState({
    role: "student",
    first_name: "",
    last_name: "",
    email: "",
    student_id: "",
    year: "",
    college: "",
    department: "",
    password: "",
    confirmPassword: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [acceptedLegal, setAcceptedLegal] = useState(false);
  const [legalConsentTouched, setLegalConsentTouched] = useState(false);
  const [colleges, setcolleges] = useState([]);
  const [menuWidths, setMenuWidths] = useState({
    year: null,
    college: null,
    department: null,
  });
  const [openSelectField, setOpenSelectField] = useState(null);
  const mainContentRef = useRef(null);

  useEffect(() => {
    const fetchColleges= async()=>{
      try {
        const response = await api.get('users/college_name/')
        // console.log(response)
        if (response && Array.isArray(response)) {
          setcolleges(response);
        }
        else{
              console.error("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Error in fetching colleges", error);
      }
    };
    fetchColleges();
  }, [])

  
  // Validation
  const validateField = (field, value, state = formData) => {
    const newErrors = { ...errors };

    switch (field) {
      case "first_name":
        if (!value.trim()) newErrors[field] = "First name is required";
        else if (value.trim().length < 2)
          newErrors[field] = "First name must be at least 2 characters";
        else if (!/^[a-zA-Z\s]+$/.test(value.trim()))
          newErrors[field] = "Only letters and spaces";
        else delete newErrors[field];
        break;

      case "last_name":
        if (!value.trim()) newErrors[field] = "Last name is required";
        else if (value.trim().length < 2)
          newErrors[field] = "Last name must be at least 2 characters";
        else if (!/^[a-zA-Z\s]+$/.test(value.trim()))
          newErrors[field] = "Only letters and spaces";
        else delete newErrors[field];
        break;

      case "email": {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!value) newErrors[field] = "Email is required";
        else if (!emailRegex.test(value))
          newErrors[field] = "Enter a valid email address";
        else delete newErrors[field];
        break;
      }

      case "student_id":
        if (!value.trim()) newErrors[field] = "Student ID is required";
        else if (value.trim().length < 4)
          newErrors[field] = "Student ID must be at least 4 characters";
        else delete newErrors[field];
        break;

      case "year":
      case "college":
      case "department":
        if (!value) newErrors[field] = "This field is required";
        else delete newErrors[field];
        break;

      case "password":
        if (!value) newErrors[field] = "Password is required";
        else if (/\s/.test(value)) newErrors[field] = "Password cannot contain spaces";
        else if (value.length < 8)
          newErrors[field] = "Password must be at least 8 characters";
        else {
          const hasLower = /[a-z]/.test(value);
          const hasUpper = /[A-Z]/.test(value);
          const hasDigit = /\d/.test(value);
          const hasSpecial = /[!@#]/.test(value);
          const allowed = "!@#";
          if (!hasLower || !hasUpper || !hasDigit || !hasSpecial) {
            newErrors[field] = `Password must include uppercase, lowercase, a number and a special character (${allowed})`;
          } else {
            delete newErrors[field];
          }
        }

        // cross-check confirm
        if (state.confirmPassword && value !== state.confirmPassword)
          newErrors.confirmPassword = "Passwords do not match";
        else if (state.confirmPassword) delete newErrors.confirmPassword;
        break;

      case "confirmPassword":
        if (!value) newErrors[field] = "Please confirm your password";
        else if (value !== state.password)
          newErrors[field] = "Passwords do not match";
        else delete newErrors[field];
        break;

      default:
        break;
    }

    setErrors(newErrors);
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    const next = { ...formData, [field]: value };
    setFormData(next);

    // If the email was changed after we sent a code, invalidate the previous OTP flow
    if (field === "email") {
      const newEmail = (value || "").trim();
      if (sentEmail && newEmail !== sentEmail) {
        setOtp("");
        setOtpSent(false);
        setOtpVerified(false);
        setOtpNotice("");
        setSubmitError("");
        setSentEmail("");
        setOtpInvalidated(true);
      }
    }

    if (touched[field]) validateField(field, value, next);
  };

  const handleBlur = (field) => (e) => {
    setTouched((t) => ({ ...t, [field]: true }));
    validateField(field, e.target.value);
  };

  const getPasswordStrength = (password) => {
    if (!password) return { strength: 0, label: "", color: "#e2e8f0" };
    let strength = 0;
    if (password.length >= 8) strength += 25;
    if (/[a-z]/.test(password)) strength += 25;
    if (/[A-Z]/.test(password)) strength += 25;
    if (/\d/.test(password)) strength += 25;

    if (strength <= 25) return { strength, label: "Weak", color: "#ef4444" };
    if (strength <= 50) return { strength, label: "Fair", color: "#f97316" };
    if (strength <= 75) return { strength, label: "Good", color: "#eab308" };
    return { strength, label: "Strong", color: "#1E3A8A" };
  };

  const passwordStrength = getPasswordStrength(formData.password);

  const handleSendOtp = async () => {
    const firstName = (formData.first_name || '').trim();
    const lastName = (formData.last_name || '').trim();
    const email = (formData.email || '').trim();

    if (!firstName) {
      setTouched((t) => ({ ...t, first_name: true }));
      validateField('first_name', firstName);
      setSubmitError('First name is required to send a verification code.');
      return;
    }
    if (!lastName) {
      setTouched((t) => ({ ...t, last_name: true }));
      validateField('last_name', lastName);
      setSubmitError('Last name is required to send a verification code.');
      return;
    }
    if (!email) {
      setTouched((t) => ({ ...t, email: true }));
      setSubmitError('Email is required to send a verification code.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setTouched((t) => ({ ...t, email: true }));
      setSubmitError('Enter a valid email address to send a verification code.');
      return;
    }

    setIsSendingOtp(true);
    setSubmitError('');
    setOtpNotice('');
    try {
      const res = await api.post('users/signup-otp/', { email });
      setOtpSent(true);
      setOtpVerified(false);
      setOtp('');
        setSentEmail(email);
        setOtpInvalidated(false);
      setOtpNotice(res?.message || "If an account for this email can be created, we’ve sent a verification code.");
      const cd = Number(res?.cooldown_seconds);
      if (Number.isFinite(cd) && cd > 0) setOtpCooldown(Math.min(600, Math.max(0, Math.floor(cd))));
    } catch (err) {
      const msg =
        err?.error ||
        err?.detail ||
        err?.message ||
        'Failed to send verification code. Please try again.';
      setSubmitError(msg);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    const firstName = (formData.first_name || '').trim();
    const lastName = (formData.last_name || '').trim();
    const email = (formData.email || '').trim();
    const otpClean = String(otp || '').trim();

    setSubmitError('');
    setOtpNotice('');

    if (!firstName) {
      setTouched((t) => ({ ...t, first_name: true }));
      validateField('first_name', firstName);
      setSubmitError('First name is required to verify the code.');
      return;
    }
    if (!lastName) {
      setTouched((t) => ({ ...t, last_name: true }));
      validateField('last_name', lastName);
      setSubmitError('Last name is required to verify the code.');
      return;
    }
    if (!email) {
      setTouched((t) => ({ ...t, email: true }));
      setSubmitError('Email is required to verify the code.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setTouched((t) => ({ ...t, email: true }));
      setSubmitError('Enter a valid email address to verify the code.');
      return;
    }
    if (!otpSent) {
      setSubmitError('Please send a verification code to your email first.');
      return;
    }
    if (!otpClean) {
      setSubmitError('Please enter the verification code sent to your email.');
      return;
    }
    if (!/^\d{6}$/.test(otpClean)) {
      setSubmitError('Please enter a valid 6-digit verification code.');
      return;
    }

    setIsVerifyingOtp(true);
    try {
      const res = await api.post('users/signup-otp/verify/', { email, otp: otpClean });
      setOtpVerified(true);
      setOtpNotice(res?.message || 'Email verified.');
    } catch (err) {
      let msg =
        err?.error ||
        err?.detail ||
        err?.message ||
        null;

      // When the backend endpoint doesn't exist (or backend not restarted),
      // some servers return HTML. Our api wrapper then throws a string.
      if (!msg && typeof err === 'string') {
        const lower = err.toLowerCase();
        const looksLikeHtml = lower.includes('<html') || lower.includes('<!doctype');
        const notFound = lower.includes('not found') || lower.includes('404');

        if (looksLikeHtml && notFound) {
          msg = 'Verify Code endpoint is not available. Please restart/redeploy the backend and try again.';
        } else {
          msg = 'Failed to verify code. Please try again.';
        }
      }

      if (!msg) msg = 'Failed to verify code. Please try again.';
      setSubmitError(msg);
      setOtpVerified(false);
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLegalConsentTouched(true);

    // touch all
    const allTouched = Object.keys(formData).reduce((acc, k) => {
      acc[k] = true;
      return acc;
    }, {});
    setTouched(allTouched);

    // run validations
    Object.entries(formData).forEach(([k, v]) => validateField(k, v));

    // if any error present after validation
    const hasErrors = Object.values(errors).some(Boolean);
    if (hasErrors) return;

    if (!(formData.first_name || '').trim() || !(formData.last_name || '').trim()) {
      setSubmitError('Please enter your first and last name.');
      return;
    }

    if (!acceptedLegal) {
      setSubmitError('You must accept the Terms of Service and Privacy Policy to create an account.');
      return;
    }

    if (!otpVerified) {
      setSubmitError('Please verify your email using the verification code.');
      return;
    }

    setIsLoading(true);
    setSubmitError("");
    try {
      const payload = {
        ...formData,
      };
      delete payload.confirmPassword;

      const response = await api.post('users/signup-otp/confirm/', payload);
      if (response) {
        const username = response?.username || response?.user?.username || response?.data?.username || '';
        const name = `${(formData.first_name || '').trim()} ${(formData.last_name || '').trim()}`.trim();
        setCreatedUser({ name, username });
        setIsSignupSuccess(true);
        setCurrentStep(3);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

    } catch (err) {
      console.error("Registration failed:", err);
      const msg =
        err?.detail ||
        err?.message ||
        'Registration failed. Please try again.';
      setSubmitError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectOpen = (field) => (event) => {
    const width = event.currentTarget?.getBoundingClientRect().width;
    if (width) {
      setMenuWidths((prev) => ({ ...prev, [field]: width }));
    }
    setOpenSelectField(field);
  };

  const handleSelectClose = () => {
    setOpenSelectField(null);
  };

  const getMenuProps = (field) => {
    const width = menuWidths[field];
    return {
      disablePortal: false,
      disableScrollLock: true,
      container: mainContentRef.current,
      sx: {
        zIndex: 1100,
      },
      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
      marginThreshold: null,
      transitionDuration: 120,
      PaperProps: {
        sx: {
          mt: 0,
          width: width || undefined,
          minWidth: width || undefined,
          maxWidth: width || undefined,
        },
      },
    };
  };

  /* -------------------- UI -------------------- */

  return (
    <Box className="registration-container">
      <Navbar />


      {/* Stepper */}
      <RegistrationStepper
        steps={registrationSteps}
        currentStep={currentStep}
        totalSteps={totalSteps}
        progressClassName="progress-bar"
      />

      {/* Main Registration Card */}
      <Container ref={mainContentRef} maxWidth="lg" sx={{ pb: 6 }}>
        <Fade in timeout={600}>
          <Paper className="main-card">
            {/* Hero */}
            <Box className="hero-header">
              <Zoom in timeout={800}>
                <Avatar className="hero-avatar">
                  <SchoolIcon sx={{ fontSize: "3.5rem" }} />
                </Avatar>
              </Zoom>

              <Typography
                variant={isMobile ? "h4" : "h3"}
                className="hero-title"
              >
                Join Your College <span style={{ color: "#1E3A8A" }}>Community</span>
              </Typography>

              <Typography variant="h6" className="hero-subtitle">
                Connect with peers, access AI-powered study tools, and transform
                your college experience with PeerCampus.
              </Typography>

              {/* Stats */}
              {/*
              <Box sx={{ mt: 2 }}>
                <Grid
                  container
                  spacing={3}
                  justifyContent="center"
                  alignItems="stretch"
                >
                  {[
                    {
                      number: "1,200+",
                      label: "Students",
                      icon: GroupsIcon,
                      color: "#1E3A8A",
                    },
                    {
                      number: "50+",
                      label: "Colleges",
                      icon: BusinessIcon,
                      color: "#1E3A8A",
                    },
                    {
                      number: "500+",
                      label: "Study Groups",
                      icon: MenuBookIcon,
                      color: "#f59e0b",
                    },
                  ].map((stat, idx) => {
                    const Icon = stat.icon;
                    return (
                      <Grid item xs={12} sm={6} md={4} key={idx}>
                        <Paper className="stat-card" sx={{ height: "100%" }}>
                          <Icon sx={{ fontSize: "1.45rem", color: stat.color, mb: 0.4 }} />
                          <Typography
                            variant="h5"
                            sx={{
                              fontWeight: 800,
                              color: stat.color,
                              mb: 0.5,
                              fontSize: { xs: "1rem", sm: "1.25rem" },
                            }}
                          >
                            {stat.number}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#64748b",
                              fontWeight: 500,
                              fontSize: { xs: ".68rem", sm: ".78rem" },
                            }}
                          >
                            {stat.label}
                          </Typography>
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
              */}
            </Box>

            {/* Form */}
            <Box sx={{ p: { xs: 4, md: 6 } }}>
              {isSignupSuccess ? (
                <Fade in timeout={500}>
                  <Box sx={{ textAlign: 'center', py: { xs: 2, md: 4 } }}>
                    <Avatar
                      sx={{
                        mx: 'auto',
                        mb: 3,
                        width: 88,
                        height: 88,
                        background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                        boxShadow: '0 24px 60px rgba(13,28,79,.18)'
                      }}
                    >
                      <CheckIcon sx={{ fontSize: 44, color: '#fff' }} />
                    </Avatar>

                    <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mb: 1 }}>
                      Account created!
                    </Typography>

                    {createdUser.name && (
                      <Typography variant="h5" sx={{ color: '#0f172a', fontWeight: 900, mb: 1 }}>
                        Welcome, {createdUser.name}!
                      </Typography>
                    )}

                    {createdUser.username ? (
                      <Typography variant="body1" sx={{ color: '#475569', mb: 3, maxWidth: 620, mx: 'auto', fontWeight: 600 }}>
                        Your username is <Box component="span" sx={{ fontWeight: 900, color: '#0D1C4F' }}>{createdUser.username}</Box>. We've also emailed it to <Box component="span" sx={{ fontWeight: 700 }}>{formData.email}</Box>.
                      </Typography>
                    ) : (
                      <Typography variant="body1" sx={{ color: '#64748b', mb: 3, maxWidth: 520, mx: 'auto' }}>
                        You're all set. Sign in to start exploring your college community.
                      </Typography>
                    )}

                    <Button
                      component={Link}
                      to="/login"
                      variant="contained"
                      size="large"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        borderRadius: 999,
                        px: 5,
                        py: 1.8,
                        fontWeight: 900,
                        textTransform: 'none',
                        background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                        boxShadow: '0 18px 40px rgba(13,28,79,.18)',
                        color: '#fff',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                          transform: 'translateY(-2px)'
                        }
                      }}
                    >
                      Go to Login
                    </Button>
                  </Box>
                </Fade>
              ) : (
                <form onSubmit={handleSubmit} noValidate>
                  <Stack spacing={5}>
                  {submitError && (
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        borderRadius: 3,
                        border: '1px solid rgba(239, 68, 68, 0.25)',
                        background: 'rgba(254, 226, 226, 0.45)'
                      }}
                    >
                      <Typography sx={{ color: '#b91c1c', fontWeight: 700 }}>
                        {submitError}
                      </Typography>
                    </Paper>
                  )}
                  {/* Personal Information */}
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        mb: 3,
                      }}
                    >
                      <Avatar className="section-avatar">
                        <PersonIcon sx={{ fontSize: '1.75rem' }} />
                      </Avatar>

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography
                          variant="h5"
                          sx={{ fontWeight: 700, color: "#1e293b" }}
                        >
                          Personal Information
                        </Typography>

                        {otpVerified && (
                          <Box
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1,
                              py: 0.4,
                              borderRadius: 999,
                              background: 'rgba(16,185,129,0.08)',
                              border: '1px solid rgba(16,185,129,0.12)',
                            }}
                            aria-live="polite"
                          >
                            <CheckIcon sx={{ fontSize: 16, color: '#059669' }} />
                            <Typography variant="caption" sx={{ color: '#059669', fontWeight: 700 }}>
                              Verified (locked)
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={3}>
                        <TextField
                          label="First Name"
                          placeholder="Enter your first name"
                          value={formData.first_name}
                          onChange={handleChange("first_name")}
                          disabled={otpVerified}
                          onBlur={handleBlur("first_name")}
                          error={touched.first_name && !!errors.first_name}
                          helperText={touched.first_name && errors.first_name}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ),
                          }}
                          className="form-field"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <TextField
                          label="Last Name"
                          placeholder="Enter your last name"
                          value={formData.last_name}
                          onChange={handleChange("last_name")}
                          disabled={otpVerified}
                          onBlur={handleBlur("last_name")}
                          error={touched.last_name && !!errors.last_name}
                          helperText={touched.last_name && errors.last_name}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <PersonIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ),
                          }}
                          className="form-field"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Email Address"
                          placeholder="your.email@college.edu"
                          value={formData.email}
                          onChange={handleChange("email")}
                          disabled={otpVerified}
                          onBlur={handleBlur("email")}
                          error={touched.email && !!errors.email}
                          helperText={touched.email && errors.email}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <EmailIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ),
                          }}
                          className="form-field"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Verification Code"
                          placeholder="6-digit code"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          disabled={otpVerified}
                          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 6 }}
                          fullWidth
                          InputProps={{
                            startAdornment: !isMobile ? (
                              <InputAdornment position="start">
                                <LockIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ) : undefined,
                          }}
                          className="form-field"
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Stack spacing={1} sx={{ height: '100%', justifyContent: 'flex-end' }}>
                          {!otpSent ? (
                            <Button
                              type="button"
                              variant="contained"
                              onClick={handleSendOtp}
                              disabled={isSendingOtp || isLoading || otpVerified}
                              sx={{
                                borderRadius: 999,
                                py: 1.55,
                                fontWeight: 900,
                                textTransform: 'none',
                                background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                boxShadow: '0 10px 26px rgba(13,28,79,.22)',
                                '&:hover': {
                                  background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                  transform: 'translateY(-1px)',
                                },
                                '&.Mui-disabled': {
                                    boxShadow: '0 10px 26px rgba(13,28,79,.22)',
                                  color: 'rgba(255,255,255,.9)',
                                },
                              }}
                              fullWidth
                            >
                              {isSendingOtp ? 'Sending…' : 'Send Code'}
                            </Button>
                          ) : (
                            <Button
                              type="button"
                              variant="contained"
                              onClick={handleSendOtp}
                              disabled={isSendingOtp || isLoading || otpCooldown > 0 || otpVerified}
                              sx={{
                                borderRadius: 999,
                                py: 1.55,
                                fontWeight: 900,
                                textTransform: 'none',
                                background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                boxShadow: '0 10px 26px rgba(13,28,79,.22)',
                                '&:hover': {
                                  background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                  transform: 'translateY(-1px)',
                                },
                                '&.Mui-disabled': {
                                  background: 'linear-gradient(135deg, rgba(13,28,79,.35), rgba(30,58,138,.35))',
                                  color: 'rgba(255,255,255,.9)',
                                },
                              }}
                            >
                              {otpCooldown > 0
                                ? `Resend in ${otpCooldown}s`
                                : (isSendingOtp ? 'Resending…' : 'Resend Code')}
                            </Button>
                          )}

                          {otpSent && (
                            <Button
                              type="button"
                              variant="contained"
                              onClick={handleVerifyOtp}
                              disabled={isVerifyingOtp || isLoading || otpVerified}
                              startIcon={otpVerified ? <CheckIcon sx={{ color: '#fff' }} /> : undefined}
                              sx={
                                otpVerified
                                  ? {
                                      borderRadius: 999,
                                      py: 1.2,
                                      fontWeight: 900,
                                      textTransform: 'none',
                                      background: 'linear-gradient(135deg, rgba(13,28,79,.85), rgba(30,58,138,.85))',
                                      color: '#fff',
                                      boxShadow: '0 10px 26px rgba(13,28,79,.18)',
                                      '&:hover': {
                                        background: 'linear-gradient(135deg, rgba(13,28,79,.9), rgba(30,58,138,.9))',
                                      },
                                      '&.Mui-disabled': {
                                        background: 'linear-gradient(135deg, rgba(13,28,79,.6), rgba(30,58,138,.6))',
                                  background: 'linear-gradient(135deg, rgba(13,28,79,.35), rgba(30,58,138,.35))',
                                      },
                                    }
                                  : {
                                      borderRadius: 999,
                                      py: 1.2,
                                      fontWeight: 900,
                                      textTransform: 'none',
                                      background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                      boxShadow: '0 10px 26px rgba(13,28,79,.16)',
                                      '&:hover': {
                                        background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                                        transform: 'translateY(-1px)',
                                      },
                                      '&.Mui-disabled': {
                                        background: 'linear-gradient(135deg, rgba(13,28,79,.35), rgba(30,58,138,.35))',
                                        color: 'rgba(255,255,255,.9)',
                                      },
                                    }
                              }
                              fullWidth
                            >
                              {otpVerified ? 'Verified' : (isVerifyingOtp ? 'Verifying…' : 'Verify Code')}
                            </Button>
                          )}
                          {otpVerified && (otpNotice || 'Email verified.') ? (
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                px: 1.5,
                                py: 1,
                                borderRadius: 999,
                                border: '1px solid rgba(13,28,79,.25)',
                                background: 'rgba(13,28,79,.08)',
                              }}
                            >
                              <CheckIcon sx={{ fontSize: 16, color: '#1E3A8A' }} />
                              <Typography variant="caption" sx={{ color: '#0f766e', fontWeight: 800 }}>
                                {otpNotice || 'Email verified.'}
                              </Typography>
                            </Box>
                          ) : (
                            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
                              {otpInvalidated
                                ? 'Email changed — send a new code to verify.'
                                : (otpNotice || (otpSent ? 'Code sent. Enter it, then verify the code.' : 'Send a code to verify your email.'))}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>

                  <Divider sx={{ my: 2, borderColor: "rgba(226,232,240,.8)" }} />

                  {/* Academic Details */}
                  {/* Academic Details */}
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                      <Avatar className="section-avatar-academic club-academic-avatar">
                        <SchoolIcon />
                      </Avatar>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b" }}>
                        Academic Details
                      </Typography>
                    </Box>

                    <Grid container spacing={3} className="academic-details-grid">
                      <Grid item xs={12} md={6} className="student-id-field">
                        <TextField
                          label="Student ID"
                          placeholder="Enter your student ID"
                          value={formData.student_id}
                          onChange={handleChange("student_id")}
                          onBlur={handleBlur("student_id")}
                          error={touched.student_id && !!errors.student_id}
                          helperText={touched.student_id && errors.student_id}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <BadgeIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ),
                          }}
                          className="form-field form-field-academic club-academic-field"
                        />
                      </Grid>

                      <Grid item xs={12} md={6} className="year-field">
                        <TextField
                          select
                          label="Year of Study"
                          value={formData.year}
                          onChange={handleChange("year")}
                          onBlur={handleBlur("year")}
                          error={touched.year && !!errors.year}
                          helperText={touched.year && errors.year}
                          required
                          fullWidth
                          SelectProps={{
                            MenuProps: getMenuProps("year"),
                            onOpen: handleSelectOpen("year"),
                            onClose: handleSelectClose,
                            open: openSelectField === "year",
                          }}
                          className="form-field form-field-academic club-academic-field"
                        >
                          {yearOptions.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} md={6} className="college-field">
                        <TextField
                          select
                          label="College"
                          value={formData.college}
                          onChange={handleChange("college")}
                          onBlur={handleBlur("college")}
                          error={touched.college && !!errors.college}
                          helperText={touched.college && errors.college}
                          required
                          fullWidth
                          SelectProps={{
                            MenuProps: getMenuProps("college"),
                            onOpen: handleSelectOpen("college"),
                            onClose: handleSelectClose,
                            open: openSelectField === "college",
                          }}
                          className="form-field form-field-academic club-academic-field"
                        >
                          {colleges.map((c) => (
                            <MenuItem key={c.id} value={c.id}>
                              {c.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12} className="department-field">
                        <TextField
                          select
                          label="Department"
                          value={formData.department}
                          onChange={handleChange("department")}
                          onBlur={handleBlur("department")}
                          error={touched.department && !!errors.department}
                          helperText={touched.department && errors.department}
                          required
                          fullWidth
                          SelectProps={{
                            MenuProps: getMenuProps("department"),
                            onOpen: handleSelectOpen("department"),
                            onClose: handleSelectClose,
                            open: openSelectField === "department",
                          }}
                          className="form-field form-field-academic club-academic-field"
                        >
                          {departmentOptions.map((d) => (
                            <MenuItem key={d} value={d}>
                              {d}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                    </Grid>
                  </Box>

                  <Divider sx={{ my: 2, borderColor: "rgba(226,232,240,.8)" }} />

                  {/* Account Security */}
                  <Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
                      <Avatar className="section-avatar-security">
                        <LockIcon />
                      </Avatar>
                      <Typography variant="h5" sx={{ fontWeight: 700, color: "#1e293b" }}>
                        Account Security
                      </Typography>
                    </Box>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <Box>
                          <TextField
                            label="Password"
                            type="password"
                            placeholder="Create a strong password"
                            value={formData.password}
                            onChange={handleChange("password")}
                            onBlur={handleBlur("password")}
                            error={touched.password && !!errors.password}
                            helperText={touched.password && errors.password}
                            required
                            fullWidth
                            aria-describedby="pw-strength-text"
                            InputProps={{
                              startAdornment: !isMobile ? (
                                <InputAdornment position="start">
                                  <LockIcon sx={{ color: "#94a3b8" }} />
                                </InputAdornment>
                              ) : undefined,
                            }}
                            className="form-field form-field-security"
                          />

                          {formData.password && (
                            <Box
                              className="password-strength-indicator"
                              sx={{ display: "flex", alignItems: "center", gap: 2 }}
                            >
                              <Box className="password-strength-bar" aria-hidden>
                                <Box
                                  className="password-strength-fill"
                                  style={{
                                    width: `${passwordStrength.strength}%`,
                                    backgroundColor: passwordStrength.color,
                                  }}
                                />
                              </Box>
                              <Typography
                                id="pw-strength-text"
                                variant="caption"
                                sx={{ color: passwordStrength.color, fontWeight: 600, minWidth: 50 }}
                                aria-live="polite"
                              >
                                {passwordStrength.label}
                              </Typography>
                            </Box>
                          )}
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <TextField
                          label="Confirm Password"
                          type="password"
                          placeholder="Confirm your password"
                          value={formData.confirmPassword}
                          onChange={handleChange("confirmPassword")}
                          onBlur={handleBlur("confirmPassword")}
                          error={touched.confirmPassword && !!errors.confirmPassword}
                          helperText={touched.confirmPassword && errors.confirmPassword}
                          required
                          fullWidth
                          InputProps={{
                            startAdornment: !isMobile ? (
                              <InputAdornment position="start">
                                <LockIcon sx={{ color: "#94a3b8" }} />
                              </InputAdornment>
                            ) : undefined,
                          }}
                          className="form-field form-field-security"
                        />
                      </Grid>
                    </Grid>
                  </Box>

                  <Box sx={{ pt: 1 }}>
                    <Box
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: 'auto minmax(0, 1fr)',
                        columnGap: { xs: 1.25, sm: 1.5 },
                        alignItems: 'start',
                        width: '100%',
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={acceptedLegal}
                        onChange={(event) => {
                          setAcceptedLegal(event.target.checked);
                          setLegalConsentTouched(true);
                        }}
                        sx={{
                          p: 0.35,
                          mt: { xs: 0.28, sm: 0.3 },
                          alignSelf: 'start',
                          color: 'rgba(13, 28, 79, 0.5)',
                          '&.Mui-checked': {
                            color: '#0D1C4F',
                          },
                        }}
                      />
                      <Box sx={{ minWidth: 0 }}>
                        <Typography component="div" sx={{ color: '#475569', lineHeight: 1.6, fontSize: { xs: '0.92rem', sm: '0.96rem' }, pt: { xs: 0.22, sm: 0.24 } }}>
                          I agree to the{' '}
                          <Box
                            component={Link}
                            to="/terms"
                            sx={{ color: '#0D1C4F', fontWeight: 700, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                          >
                            Terms of Service
                          </Box>
                          {' '}and acknowledge the{' '}
                          <Box
                            component={Link}
                            to="/privacy"
                            sx={{ color: '#0D1C4F', fontWeight: 700, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                          >
                            Privacy Policy
                          </Box>
                          .
                        </Typography>
                        {legalConsentTouched && !acceptedLegal && (
                          <Typography sx={{ mt: 0.5, color: '#b91c1c', fontSize: '0.82rem', fontWeight: 700 }}>
                            Accept the Terms of Service and Privacy Policy to continue.
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* Submit */}
                  <Box sx={{ pt: 2 }}>
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      disabled={isLoading || Object.keys(errors).length > 0}
                      endIcon={!isLoading && <ArrowForwardIcon />}
                      className="submit-button"
                      sx={{
                        borderRadius: 999,
                        px: 4,
                        py: 1.2,
                        fontWeight: 800,
                        textTransform: 'none',
                        background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                        boxShadow: '0 10px 26px rgba(13,28,79,.16)',
                        '&:hover': {
                          background: 'linear-gradient(135deg, #0D1C4F, #1E3A8A)',
                          transform: 'translateY(-1px)'
                        },
                        '&.Mui-disabled': { boxShadow: 'none', opacity: 0.6 }
                      }}
                    >
                      {isLoading ? (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Box className="loading-spinner" />
                          Creating Account...
                        </Box>
                      ) : (
                        "Create My Account"
                      )}
                    </Button>
                  </Box>
                </Stack>
                </form>
              )}

              {/* Footer CTA */}
              <Box
                sx={{
                  mt: 3.5,
                  pt: 2.5,
                  textAlign: "center",
                  borderTop: "1px solid rgba(226,232,240,.5)",
                }}
              >
                <Typography variant="body1" sx={{ color: "#64748b", mb: 2, whiteSpace: 'nowrap' }}>
                  Already have an account?{" "}
                  <Box
                    component={Link}
                    to="/login"
                    sx={{
                      color: "#1E3A8A",
                      fontWeight: 600,
                      cursor: "pointer",
                      textDecoration: "none",
                      px: 0.5,
                      py: 0.25,
                      borderRadius: 1,
                      background: 'transparent',
                      transition: 'color .18s ease, text-decoration-color .18s ease',
                      "&:hover": {
                        textDecoration: "underline",
                        textDecorationColor: 'rgba(13,28,79,0.18)',
                        textDecorationThickness: '2px',
                        textUnderlineOffset: '3px',
                        color: '#0b2746',
                        background: 'transparent'
                      },
                    }}
                  >
                    Sign in here
                  </Box>
                </Typography>

                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 2, sm: 4 }}
                  justifyContent="center"
                  alignItems={{ xs: 'flex-start', sm: 'center' }}
                  flexWrap="wrap"
                  sx={{ width: { xs: 'fit-content', sm: 'auto' }, mx: 'auto' }}
                >
                  {["Flexible Plans", "No Credit Card", "Instant Setup"].map((t) => (
                    <Box
                      key={t}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                      }}
                    >
                      <CheckIcon sx={{ color: "#1E3A8A", fontSize: 18 }} />
                      <Typography variant="body2" sx={{ color: "#64748b", fontWeight: 500 }}>
                        {t}
                      </Typography>
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Box>
          </Paper>
        </Fade>
      </Container>

      <Footer />
    </Box>
  );
};

export default ModernStudentRegistration;